import { nativeApi } from '@/../../common/src/utils/nativeApi';
import { Platform } from '@/../../common/src/utils/nativeApi/interface';
import { trackFacebookCapi } from '@/appApi';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import { getGlobalUserInfo } from './singletonUtils';

export enum trackType {
  SENSORS = 'sensors', // 神策
  GA4 = 'ga4', // Google Analytics 4
  PIXEL = 'pixel', // Facebook Pixel
  AF = 'appsflyer', // Appsflyer
  CAPI = 'capi', // Facebook CAPI
}

export enum CapiActionSource {
  WEBSITE = 'website',
  APP = 'app',
}

export const trackEvent = (type: Array<trackType>, eventName: string, eventParam?: any) => {
  console.log(type, eventName, eventParam);
  if (type.length) {
    type.forEach((item) => {
      switch (item) {
        case trackType.SENSORS:
          sensors.track(eventName, eventParam);
          break;
        case trackType.GA4:
          ReactGA.event(eventName, eventParam);
          break;
        case trackType.PIXEL:
          ReactPixel.trackCustom(eventName, eventParam);
          nativeApi.fbTrackEvent?.(eventName, eventParam);
          break;
        case trackType.AF:
          nativeApi.afTrackEvent?.(eventName, eventParam);
          break;
        case trackType.CAPI:
          trackFacebookCapi({
            actionSource: [Platform.Crefit, Platform.MyLink].includes(nativeApi.name)
              ? CapiActionSource.APP
              : CapiActionSource.WEBSITE,
            eventName,
            customData: { ...eventParam, contentName: eventName },
            eventSourceUrl: location.href,
            eventTime: Date.now(),
            userData: {
              clientUserAgent: navigator.userAgent,
            },
          }).then(() => {});
          break;
      }
    });
  }
};

// 進行用戶id的綁定，在CreFIT中則不進行綁定（因為CreFIT中原生已經綁定）
export const sensorTrackUserInfo = async () => {
  if (nativeApi.name === Platform.Crefit) return;
  const userInfo = await getGlobalUserInfo();
  sensors.login(userInfo.userId);
  console.log('sensorTrackUserInfo', userInfo.userId);
};
